import { Fragment } from 'react';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

const AppToastContainer = ({ listOfToasts, onExpiry }) => {
  return (
    <ToastContainer position="bottom-end" className="p-3" style={{ zIndex: 1056 }}>
      {
        listOfToasts.length > 0
          ? (
            listOfToasts.map(function (toast, _) {
              return (
                <Toast
                  bg={toast.variant.toLowerCase()}
                  key={`toast_container_${toast.id}`}
                  onClose={() => onExpiry(toast.id)}
                  delay={toast.delay}
                  autohide
                >
                  <Toast.Header>
                    <strong className="me-auto">{toast.name}</strong>
                    <small>{toast.id}</small>
                  </Toast.Header>
                  <Toast.Body>{toast.content}</Toast.Body>
                </Toast>
              );
            }))
          : <Fragment></Fragment>
      }
    </ToastContainer >
  );
};

export default AppToastContainer;